import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated results list
 */
export default class ResultsList extends PaginatedList {
  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
    this.setAttribute('initialized', '');

    this.#zenovaScrollToProductsAfterCategory();
  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
  }

  /**
   * Zenova custom:
   * se l'URL contiene #products o #ResultsList, scrolla alla griglia prodotti.
   */
  #zenovaScrollToProductsAfterCategory() {
    const hash = window.location.hash;

    if (hash !== '#products' && hash !== '#ResultsList') return;

    const scrollToGrid = () => {
      const grid =
        this.querySelector('.product-grid[data-testid="product-grid"]') ||
        this.querySelector('[data-testid="product-grid"]') ||
        this.querySelector('.product-grid') ||
        document.querySelector('.product-grid[data-testid="product-grid"]') ||
        document.querySelector('[data-testid="product-grid"]') ||
        document.querySelector('.product-grid');

      if (!grid) return;

      const headerOffset = window.innerWidth < 750 ? 90 : 115;
      const extraDown = window.innerWidth < 750 ? 35 : 55;

      const top =
        grid.getBoundingClientRect().top +
        window.pageYOffset -
        headerOffset +
        extraDown;

      window.scrollTo({
        top,
        behavior: 'smooth',
      });
    };

    window.setTimeout(scrollToGrid, 300);
    window.setTimeout(scrollToGrid, 800);
    window.setTimeout(scrollToGrid, 1400);
  }

  /**
   * Updates the layout.
   *
   * @param {Event} event
   */
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;

    this.#animateLayoutChange(target.value);
  }

  /**
   * Sets the layout.
   *
   * @param {string} value
   */
  #animateLayoutChange = async (value) => {
    const { grid } = this.refs;

    if (!grid) return;

    await startViewTransition(() => this.#setLayout(value), ['product-grid']);

    requestIdleCallback(() => {
      const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
      sessionStorage.setItem(`product-grid-view-${viewport}`, value);
    });
  };

  /**
   * Animates the layout change.
   *
   * @param {string} value
   */
  #setLayout(value) {
    const { grid } = this.refs;

    if (!grid) return;

    grid.setAttribute('product-grid-view', value);
  }

  /**
   * Handles the media query change event.
   *
   * @param {MediaQueryListEvent} event
   */
  #handleMediaQueryChange = (event) => {
    const targetElement = event.matches
      ? this.querySelector('[data-grid-layout="desktop-default-option"]')
      : this.querySelector('[data-grid-layout="mobile-option"]');

    if (!(targetElement instanceof HTMLInputElement)) return;

    targetElement.checked = true;
    this.#setLayout('default');
  };
}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}